import { useContext } from 'react';
import AppContext from 'contexts/appContext';
import ViewsContext from 'contexts/viewsContext';

export default function SetChartGlobals() {
    const { appState } = useContext(AppContext);
    const { viewsState } = useContext(ViewsContext);

    if (appState.theme === 'light-theme') {
        window.Chart.defaults.global.defaultFontColor = 'rgba(64, 64, 64, 1)';
        window.Chart.defaults.scale.gridLines.color = 'rgba(0, 0, 0, 0.1)';
        window.Chart.defaults.scale.gridLines.zeroLineColor = 'rgba(0, 0, 0, 0.25)';
    }
    if (appState.theme === 'dark-theme') {
        window.Chart.defaults.global.defaultFontColor = 'rgba(220, 220, 220, 1)';
        window.Chart.defaults.scale.gridLines.color = 'rgba(220, 220, 220, 0.2)';
        window.Chart.defaults.scale.gridLines.zeroLineColor = 'rgba(220, 220, 220, 0.4)';
    }
    if (appState.theme === 'nav-theme') {
        window.Chart.defaults.global.defaultFontColor = 'rgba(0, 0, 0, 1)';
        window.Chart.defaults.scale.gridLines.color = 'rgba(0, 0, 0, 0.3)';
        window.Chart.defaults.scale.gridLines.zeroLineColor = 'rgba(0, 0, 0, 0.5)';
    }

}

export function HourlySalesCumuChartThemeVars(calculatedData) {

    const { appState } = useContext(AppContext);
    const { viewsState } = useContext(ViewsContext);

    if (appState.theme === 'light-theme') {
        calculatedData = {
            'labels': [],
            'datasets': [{
                'showLine': true,
                'spanGaps': false,
                'steppedLine': false,
                'data': [],
                'fill': true,
                'label': viewsState.chartsAndTableViewsConfigs.hourlySalesCumuLineChart.activeDimention,
                'lineTension': 0,
                'backgroundColor':
                    'rgba(102,153,162,0.2)',
                'borderColor':
                    'rgba(102,153,162,0.6)',
                'borderWidth': 0,
                'borderDashOffset': 0,
                'pointBackgroundColor': 'rgba(240,240,240,1)',
                'pointBorderColor': 'rgba(102,153,162,1)',
                'pointBorderWidth': 1,
                'pointRadius': 8,
                'pointHoverRadius': 10,
                'pointHitRadius': 12,
                'pointHoverBackgroundColor':
                    'rgba(102,153,162,1)',
                'pointHoverBorderColor': 'rgba(102,153,162,1)',
                'pointHoverBorderWidth': 2
            }]
        };
    }
    if (appState.theme === 'dark-theme') {
        calculatedData = {
            'labels': [],
            'datasets': [{
                'showLine': true,
                'spanGaps': false,
                'steppedLine': false,
                'data': [],
                'fill': true,
                'label': viewsState.chartsAndTableViewsConfigs.hourlySalesCumuLineChart.activeDimention,
                'lineTension': 0,
                'backgroundColor': 'rgba(235,254,255,0.2)',
                'borderColor': 'rgba(235,254,255,0.6)',
                'borderWidth': 0,
                'borderDashOffset': 0,
                'pointBackgroundColor': 'rgba(240,240,240,1)',
                'pointBorderColor': 'rgba(235,254,255,1)',
                'pointBorderWidth': 1,
                'pointRadius': 8,
                'pointHoverRadius': 10,
                'pointHitRadius': 12,
                'pointHoverBackgroundColor': 'rgba(235,254,255,1)',
                'pointHoverBorderColor': 'rgba(235,254,255,1)',
                'pointHoverBorderWidth': 2
            }
            ]
        };
    }
    if (appState.theme === 'nav-theme') {
        calculatedData = {
            'labels': [],
            'datasets': [{
                'showLine': true,
                'spanGaps': false,
                'steppedLine': false,
                'data': [],
                'fill': true,
                'label': viewsState.chartsAndTableViewsConfigs.hourlySalesCumuLineChart.activeDimention,
                'lineTension': 0,
                'backgroundColor': 'rgba(230,128,37,0.2)',
                'borderColor': 'rgba(230,128,37,0.6)',
                'borderWidth': 0,
                'borderDashOffset': 0,
                'pointBackgroundColor': 'rgba(240,240,240,1)',
                'pointBorderColor': 'rgba(230,128,37,1)',
                'pointBorderWidth': 1,
                'pointRadius': 8,
                'pointHoverRadius': 10,
                'pointHitRadius': 12,
                'pointHoverBackgroundColor': 'rgba(230,128,37,1)',
                'pointHoverBorderColor': 'rgba(230,128,37,1)',
                'pointHoverBorderWidth': 2
            }
            ]
        };
    }
    return calculatedData;
}

export function HourlySalesChartThemeVars(calculatedData) {

    const { appState } = useContext(AppContext);
    const { viewsState } = useContext(ViewsContext);

    if (appState.theme === 'light-theme') {
        calculatedData = {
            'labels': [],
            'datasets': [{
                'data': [],
                'label': viewsState.chartsAndTableViewsConfigs.hourlySalesBarChart.activeDimention,
                'backgroundColor': 'rgba(126,171,132,0.3)',
                'borderColor': 'rgba(126,171,132,1)',
                'borderWidth': 1,
                'hoverBackgroundColor': 'rgba(126,171,132,0.6)',
                'hoverBorderColor': 'rgba(126,171,132,1)',
                'hoverBorderWidth': 2
            }]
        };
    }
    if (appState.theme === 'dark-theme') {
        calculatedData = {
            'labels': [],
            'datasets': [{
                'data': [],
                'label': viewsState.chartsAndTableViewsConfigs.hourlySalesBarChart.activeDimention,
                'backgroundColor': 'rgba(244,255,246,0.3)',
                'borderColor': 'rgba(244,255,246,1)',
                'borderWidth': 1,
                'hoverBackgroundColor': 'rgba(244,255,246,0.6)',
                'hoverBorderColor': 'rgba(244,255,246,1)',
                'hoverBorderWidth': 2
            }
            ]
        };
    }
    if (appState.theme === 'nav-theme') {
        calculatedData = {
            'labels': [],
            'datasets': [{
                'data': [],
                'label': viewsState.chartsAndTableViewsConfigs.hourlySalesBarChart.activeDimention,
                'backgroundColor': 'rgba(230,128,37,0.3)',
                'borderColor': 'rgba(230,128,37,1)',
                'borderWidth': 1,
                'hoverBackgroundColor': 'rgba(230,128,37,0.6)',
                'hoverBorderColor': 'rgba(230,128,37,1)',
                'hoverBorderWidth': 2
            }
            ]
        };
    }
    return calculatedData;
}

export function HourlyLaborChartThemeVars(calculatedData) {

    const { appState } = useContext(AppContext);
    const { viewsState } = useContext(ViewsContext);

    if (appState.theme === 'light-theme') {
        calculatedData = {
            'labels': [],
            'datasets': [{
                'data': [],
                'label': viewsState.chartsAndTableViewsConfigs.hourlySalesBarChart.activeDimention,
                'backgroundColor': 'rgba(195,120,72,0.3)',
                'borderColor': 'rgba(195,120,72,1)',
                'borderWidth': 1,
                'hoverBackgroundColor': 'rgba(195,120,72,0.6)',
                'hoverBorderColor': 'rgba(195,120,72,1)',
                'hoverBorderWidth': 2
            }]
        };
    }
    if (appState.theme === 'dark-theme') {
        calculatedData = {
            'labels': [],
            'datasets': [{
                'data': [],
                'label': viewsState.chartsAndTableViewsConfigs.hourlySalesBarChart.activeDimention,
                'backgroundColor': 'rgba(255,241,223,0.3)',
                'borderColor': 'rgba(255,241,223,1)',
                'borderWidth': 1,
                'hoverBackgroundColor': 'rgba(255,241,223,0.6)',
                'hoverBorderColor': 'rgba(255,241,223,1)',
                'hoverBorderWidth': 2
            }
            ]
        };
    }
    if (appState.theme === 'nav-theme') {
        calculatedData = {
            'labels': [],
            'datasets': [{
                'data': [],
                'label': viewsState.chartsAndTableViewsConfigs.hourlySalesBarChart.activeDimention,
                'backgroundColor': 'rgba(230,128,37,0.3)',
                'borderColor': 'rgba(230,128,37,1)',
                'borderWidth': 1,
                'hoverBackgroundColor': 'rgba(230,128,37,0.6)',
                'hoverBorderColor': 'rgba(230,128,37,1)',
                'hoverBorderWidth': 2
            }
            ]
        };
    }
    return calculatedData;
}

export function HourlyLaborCumuChartThemeVars(calculatedData) {

    const { appState } = useContext(AppContext);
    const { viewsState } = useContext(ViewsContext);

    if (appState.theme === 'light-theme') {
        calculatedData = {
            'labels': [],
            'datasets': [{
                'showLine': true,
                'spanGaps': false,
                'steppedLine': false,
                'data': [],
                'fill': true,
                'label': viewsState.chartsAndTableViewsConfigs.hourlySalesCumuLineChart.activeDimention,
                'lineTension': 0,
                'backgroundColor': 'rgba(171,123,225,0.2)',
                'borderColor': 'rgba(171,123,225,0.6)',
                'borderWidth': 0,
                'borderDashOffset': 0,
                'pointBackgroundColor': 'rgba(240,240,240,1)',
                'pointBorderColor': 'rgba(171,123,225,1)',
                'pointBorderWidth': 1,
                'pointRadius': 8,
                'pointHoverRadius': 10,
                'pointHitRadius': 12,
                'pointHoverBackgroundColor': 'rgba(171,123,225,1)',
                'pointHoverBorderColor': 'rgba(171,123,225,1)',
                'pointHoverBorderWidth': 2

            }]
        };
    }
    if (appState.theme === 'dark-theme') {
        calculatedData = {
            'labels': [],
            'datasets': [{
                'showLine': true,
                'spanGaps': false,
                'steppedLine': false,
                'data': [],
                'fill': true,
                'label': viewsState.chartsAndTableViewsConfigs.hourlySalesCumuLineChart.activeDimention,
                'lineTension': 0,
                'backgroundColor': 'rgba(255,243,255,0.2)',
                'borderColor': 'rgba(255,243,255,0.6)',
                'borderWidth': 0,
                'borderDashOffset': 0,
                'pointBackgroundColor': 'rgba(240,240,240,1)',
                'pointBorderColor': 'rgba(255,243,255,1)',
                'pointBorderWidth': 1,
                'pointRadius': 8,
                'pointHoverRadius': 10,
                'pointHitRadius': 12,
                'pointHoverBackgroundColor': 'rgba(255,243,255,1)',
                'pointHoverBorderColor': 'rgba(255,243,255,1)',
                'pointHoverBorderWidth': 2
            }
            ]
        };
    }
    if (appState.theme === 'nav-theme') {
        calculatedData = {
            'labels': [],
            'datasets': [{
                'showLine': true,
                'spanGaps': false,
                'steppedLine': false,
                'data': [],
                'fill': true,
                'label': viewsState.chartsAndTableViewsConfigs.hourlySalesCumuLineChart.activeDimention,
                'lineTension': 0,
                'backgroundColor': 'rgba(230,128,37,0.2)',
                'borderColor': 'rgba(230,128,37,0.6)',
                'borderWidth': 0,
                'borderDashOffset': 0,
                'pointBackgroundColor': 'rgba(240,240,240,1)',
                'pointBorderColor': 'rgba(230,128,37,1)',
                'pointBorderWidth': 1,
                'pointRadius': 8,
                'pointHoverRadius': 10,
                'pointHitRadius': 12,
                'pointHoverBackgroundColor': 'rgba(230,128,37,1)',
                'pointHoverBorderColor': 'rgba(230,128,37,1)',
                'pointHoverBorderWidth': 2
            }
            ]
        };
    }
    return calculatedData;
}


export function CostCenterChartThemeVars(calculatedData) {

    const { appState } = useContext(AppContext);
    const { viewsState } = useContext(ViewsContext);

    if (appState.theme === 'light-theme') {
        calculatedData = {
            'labels': [],
            'datasets': [{
                'data': [],
                'label': viewsState.chartsAndTableViewsConfigs.hourlySalesBarChart.activeDimention,
                'backgroundColor': 'rgba(240,105,141,0.3)',
                'borderColor': 'rgba(240,105,141,1)',
                'borderWidth': 1,
                'hoverBackgroundColor': 'rgba(240,105,141,0.6)',
                'hoverBorderColor': 'rgba(240,105,141,1)',
                'hoverBorderWidth': 2
            }]
        };
    }
    if (appState.theme === 'dark-theme') {
        calculatedData = {
            'labels': [],
            'datasets': [{
                'data': [],
                'label': viewsState.chartsAndTableViewsConfigs.hourlySalesBarChart.activeDimention,
                'backgroundColor': 'rgba(255,236,250,0.3)',
                'borderColor': 'rgba(255,236,250,1)',
                'borderWidth': 1,
                'hoverBackgroundColor': 'rgba(255,236,250,0.6)',
                'hoverBorderColor': 'rgba(255,236,250,1)',
                'hoverBorderWidth': 2
            }
            ]
        };
    }
    if (appState.theme === 'nav-theme') {
        calculatedData = {
            'labels': [],
            'datasets': [{
                'data': [],
                'label': viewsState.chartsAndTableViewsConfigs.hourlySalesBarChart.activeDimention,
                'backgroundColor': 'rgba(230,128,37,0.3)',
                'borderColor': 'rgba(230,128,37,1)',
                'borderWidth': 1,
                'hoverBackgroundColor': 'rgba(230,128,37,0.6)',
                'hoverBorderColor': 'rgba(230,128,37,1)',
                'hoverBorderWidth': 2
            }
            ]
        };
    }
    return calculatedData;
}

export function CategorySalesChartThemeVars(calculatedData) {

    const { appState } = useContext(AppContext);
    const { viewsState } = useContext(ViewsContext);

    if (appState.theme === 'light-theme') {
        calculatedData = {
            'labels': [],
            'datasets': [{
                'data': [],
                'label': viewsState.chartsAndTableViewsConfigs.hourlySalesBarChart.activeDimention,
                'backgroundColor': 'rgba(60,123,213,0.3)',
                'borderColor': 'rgba(60,123,213,1)',
                'borderWidth': 1,
                'hoverBackgroundColor': 'rgba(60,123,213,0.6)',
                'hoverBorderColor': 'rgba(60,123,213,1)',
                'hoverBorderWidth': 2
            }]
        };
    }
    if (appState.theme === 'dark-theme') {
        calculatedData = {
            'labels': [],
            'datasets': [{
                'data': [],
                'label': viewsState.chartsAndTableViewsConfigs.hourlySalesBarChart.activeDimention,
                'backgroundColor': 'rgba(218,243,255,0.3)',
                'borderColor': 'rgba(218,243,255,1)',
                'borderWidth': 1,
                'hoverBackgroundColor': 'rgba(218,243,255,0.6)',
                'hoverBorderColor': 'rgba(218,243,255,1)',
                'hoverBorderWidth': 2
            }
            ]
        };
    }
    if (appState.theme === 'nav-theme') {
        calculatedData = {
            'labels': [],
            'datasets': [{
                'data': [],
                'label': viewsState.chartsAndTableViewsConfigs.hourlySalesBarChart.activeDimention,
                'backgroundColor': 'rgba(230,128,37,0.3)',
                'borderColor': 'rgba(230,128,37,1)',
                'borderWidth': 1,
                'hoverBackgroundColor': 'rgba(230,128,37,0.6)',
                'hoverBorderColor': 'rgba(230,128,37,1)',
                'hoverBorderWidth': 2
            }
            ]
        };
    }
    return calculatedData;
}

